import { useEffect, useState } from "react";
import { authenticate } from "../../services/api.service";
import "./Login.css";
import {toast} from "react-hot-toast";
import { palette } from "../../assets/theme/theme";
import { Input, TextField } from "@mui/material";
import LoginIcon from '@mui/icons-material/Login';
import CustomButtonSimple from "../../components/CustomMiscellaneous/CustomButtonSimple";
import rodrimaq_icon from '../../assets/img/Alternative_logo.png';




   const animationStyle= {
    animationName: 'login-spin', animationTimingFunction: 'linear', animationIterationCount: 'infinite', animationDuration: '5000ms'
   }


export default function Login ({setUser }: any) {

    const [errorMessages, setErrorMessages] = useState<any>({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");


    useEffect(()=> {
        console.log("Email: ", email);
        console.log("Psswd: ", password);
    }, [email, password])


    const renderErrorMessage = (name : string) =>
        name === errorMessages.name && (
    <div className="error">{errorMessages.message}</div>
  );

  const submit = async () => {
    try {
        console.log("Submitting info: ", {email, password})
        const response = await authenticate({email, password});
        setUser(response.token);
        toast.success((t) => (
            <span>
                <span>Autenticação efetuada com sucesso!!</span>
            </span>
          ))
    } catch(e) {
        setErrorMessages({name: "pass", message: 'Credenciais de autenticação incorretas'})
        setTimeout(()=> {
            setErrorMessages({})
        }, 2000);
        
    }
   
  }

  const validateEmail = (email : string) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };


  const handleEmailChange = (e : Event) => {
    const email = (e?.target as HTMLInputElement).value;
    setEmail(email);
    if(!validateEmail(email)) {
        setErrorMessages({name: "email", message: 'Formatação de e-mail incorreta'})
    } else {
        setErrorMessages({})
    }
  }


    return (<div className="flex w-full h-screen">
        <div className="w-3/5 flex  h-full bg-rodrimaq-red text-white p-8 justify-center items-center">
            
            <div className="flex items-center">
                <div className="mr-6">
                    <img style={{...animationStyle}} src={rodrimaq_icon} width={70} height={70}/>
                </div>
                
                <h1 className="text-[4em]">Rodrimaq</h1>
                
            </div>
            
            {/* <div style={{marginTop: 50}}>Aplicação para gestão interna de faturação e de processos</div> */}
            
        </div>
        <div className="flex w-full items-center content-center justify-center">
                
                <form className="w-1/3 h-auto p-5 border border-gray-400 rounded-lg">
                    <h2 className="text-lg font-bold">Log in</h2>
                    <div className="input-container">
                        <label>Email </label>
                        <TextField
                            value={email}
                            label={"Introduzir email"}
                            onChange={(e : any)=> handleEmailChange(e)}
                            variant={'outlined'}
                            name="uname"

                        />
                        {renderErrorMessage("email")}
                                              
                    </div>
                    <div className="input-container">
                        <label>Password </label>
                        <TextField
                            label={"Introduzir password"}
                            onChange={(e : any)=> setPassword(e.target.value)}
                            variant={'outlined'}
                            type='password'
                            name="pass"
                        />
                        {renderErrorMessage("pass")}
                    </div>
                    <div style={{marginTop: '30px', width:'100%', display: 'flex', justifyContent: 'end'}}>
                        <CustomButtonSimple disabled={password.length==0 || !validateEmail(email)} onClick={submit} text={"Sign in"} Icon={LoginIcon} color={palette.rodrimaq_red}/>
                    </div>
                </form>
                


        </div>
    </div>)


}